// extracted by mini-css-extract-plugin
export var active = "_4e-7";
export var container = "_4e-0";
export var evenWidth = "_4e-4";
export var large = "_4e-5";
export var outlet = "_4e-8";
export var slide = "_4e-2";
export var small = "_4e-6";
export var tab = "_4e-3";
export var tabs = "_4e-1";